export function slugify(str) {
    str = str.toLowerCase();
    str = str.replace(/[^a-z0-9 -]/g, ''); // Remove special characters
    str = str.replace(/\s+/g, '-'); // Replace spaces with hyphens
    return str;
}